import axios from "axios";

const API = axios.create({
  baseURL: "https://api.scoriva.net/api", // öz backend url
});

export const aboutTextApi = {
  get: () => API.get("/about-text"),
};
